import React from 'react';
import { bool, func, object } from 'prop-types';

import moment from 'moment';

import s from './FamilyMemberItem.css';
import cx from 'classnames';


const FamilyMemberItem = ({ ...props }) => {

  const switchAccount = () => {

    const successCallback = () => props.onSwitch();

    const errorCallback = response =>
      props.openErrorDialog({
        content: response.message.body,
        okCallback: props.closeAlertDialog,
      });

    props.chooseAccount(props.member.patientId, successCallback, errorCallback);

  };

  const renderCheckMark = () =>
    <svg className={s.checkmark} version="1.1"x="0px" y="0px" viewBox="0 0 26.9 20.4">
      <path className={s.checkmarkPath} d="M8.3,19.8l-7.5-7.5c-0.8-0.8-0.8-2,0-2.8l0,0c0.8-0.8,2-0.8,2.8,0L9.1,15L23.3,0.8c0.8-0.8,2-0.8,2.8,0l0,0c0.8,0.8,0.8,2,0,2.8L10,19.8C9.5,20.3,8.8,20.3,8.3,19.8z"/>
    </svg>;

  const dob = typeof props.member.dob === 'number' ?
    moment(props.member.dob).utc().format('MMM DD, YYYY') :
    moment(props.member.dob, "YYYY-MM-DD").format('MMM DD, YYYY');

  const renderInitials = () => {
    if (props.member.firstName && props.member.lastName) {
      return props.member.firstName.charAt(0) + props.member.lastName.charAt(0);
    }
  };

  const switchButton = <button onClick={switchAccount} className={s.button}>Switch</button>;

  return (
    <div className={cx(s.component, {[`${s.active}`]: props.active})}>
      <div className={cx(s.static, s.initials, s.secondaryText)}>
        <span>
            {renderInitials()}
        </span>
      </div>
      <div className={cx(s.flex, s.info)}>
        <h2 className={s.primaryText}>
          <span>{props.member.firstName + ' ' + props.member.lastName}</span>
          {props.primary && <span className={s.secondaryText}> (Me)</span>}
        </h2>
        <p className={s.secondaryText}>{dob}</p>
        <p className={s.secondaryText}>{props.member.age + ' years old'}</p>
      </div>
      <div className={cx(s.static)}>
        {!props.active && switchButton}
        {props.active && renderCheckMark()}
      </div>
    </div>
  );
};

FamilyMemberItem.propTypes = {
  active: bool,
  closeAlertDialog: func,
  chooseAccount: func,
  member: object.isRequired,
  primary: bool,
  openErrorDialog: func,
  onSwitch: func,
};

export default FamilyMemberItem;



// WEBPACK FOOTER //
// ./src/components/Pages/Family/FamilyMemberItem/FamilyMemberItem.js